import React from 'react';
import UserForm from '../UserForm';

const MySettings = (props) => (
  <UserForm {...props} screen="mySettings" submitLabel="Save" showCancel={false} showCreateAnother={false} />
);

export default MySettings;
